import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { getRelatedProjects, PROJECTS } from '../constants/projects';
import './ProjectDetail.css';

const ProjectDetail = () => {
  const { projectId } = useParams();
  const project = PROJECTS[projectId];

  if (!project) {
    return (
      <main className="project-detail-page">
        <div className="project-detail-page__container">
          <div className="project-detail-not-found">
            <h1>Project not found</h1>
            <p>The project you are looking for does not exist or may have been moved.</p>
            <Link to="/projects" className="project-detail-btn project-detail-btn--primary">
              Back to projects
            </Link>
          </div>
        </div>
      </main>
    );
  }

  const relatedProjects = getRelatedProjects(projectId);

  return (
    <main className="project-detail-page">
      <section className="project-detail-hero">
        <img src={project.image} alt={project.title} className="project-detail-hero__img" />
        <div className="project-detail-hero__overlay" />
        <div className="project-detail-hero__content">
          <Link to="/projects" className="project-detail-hero__back">
            <i className="fa-solid fa-arrow-left" aria-hidden="true" />
            All projects
          </Link>
          <span className="project-detail-hero__tag">Project</span>
          <h1 className="project-detail-hero__title">{project.title}</h1>
          <p className="project-detail-hero__summary">{project.description}</p>
        </div>
      </section>

      <div className="project-detail-page__container">
        <div className="project-detail-layout">
          <div className="project-detail-main">
            <section className="project-detail-section">
              <h2>Project overview</h2>
              <p>{project.overview}</p>
            </section>

            <section className="project-detail-section">
              <h2>Scope of work</h2>
              <ul className="project-detail-scope">
                {project.scope.map((item) => (
                  <li key={item}>
                    <i className="fa-solid fa-check" aria-hidden="true" />
                    {item}
                  </li>
                ))}
              </ul>
            </section>
          </div>

          <aside className="project-detail-sidebar">
            <div className="project-detail-info-card">
              <h3>Project details</h3>
              <dl className="project-detail-info">
                <div>
                  <dt>Client</dt>
                  <dd>{project.client}</dd>
                </div>
                <div>
                  <dt>Timeline</dt>
                  <dd>{project.timeline}</dd>
                </div>
                <div>
                  <dt>Budget</dt>
                  <dd>{project.budget}</dd>
                </div>
                <div>
                  <dt>Location</dt>
                  <dd>{project.location}</dd>
                </div>
              </dl>
            </div>

            <div className="project-detail-cta-card">
              <h3>Interested in a similar project?</h3>
              <p>Get in touch with our team for a free consultation and quote.</p>
              <Link to="/contact" className="project-detail-btn project-detail-btn--primary">
                Contact us
                <i className="fa-solid fa-arrow-right" aria-hidden="true" />
              </Link>
            </div>
          </aside>
        </div>

        {relatedProjects.length > 0 && (
          <section className="project-detail-related">
            <h2>More projects</h2>
            <div className="project-detail-related__grid">
              {relatedProjects.map((item) => (
                <article key={item.slug} className="project-detail-related__card">
                  <Link to={item.url}>
                    <img src={item.img} alt={item.title} />
                    <div className="project-detail-related__body">
                      <h3>{item.title}</h3>
                      <span>View project</span>
                    </div>
                  </Link>
                </article>
              ))}
            </div>
          </section>
        )}
      </div>
    </main>
  );
};

export default ProjectDetail;
